import { render, staticRenderFns } from "./simulacao-seguro-saude.html?vue&type=template&id=8481be30&scoped=true&"
import script from "./simulacao-seguro-saude.js?vue&type=script&lang=js&"
export * from "./simulacao-seguro-saude.js?vue&type=script&lang=js&"
import style0 from "./simulacao-seguro-saude.scss?vue&type=style&index=0&id=8481be30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8481be30",
  null
  
)

export default component.exports